<template>
  <div>
    <v-select
      variant="outlined"
      v-model="currentLocale"
      :items="formattedLocales"
      item-title="text"
      item-value="value"
    />
  </div>
</template>

<script>
import bus, { eventNames } from '@/lib/eventBus'
import featureNames from '@/lib/featureNames'

import I18n from '../i18n'
import UPDATE_USER_LOCALE from '../modules/settings/profileSettings/queries/UpdateUserLocale.gql'

const { availableLocales, changeLocale } = I18n

export default {
  data() {
    return {
      currentLocale: this.$i18n.locale,
    }
  },
  watch: {
    '$i18n.locale': {
      immediate: true,
      handler(newLocale) {
        this.currentLocale = newLocale
      },
    },
    async currentLocale(newLocale, oldLocale) {
      if (newLocale && newLocale !== oldLocale) {
        await this.handleLocaleChange(newLocale)
      }
    },
  },
  computed: {
    availableLocales() {
      const feature = this.$features.feature('i18n')
      return availableLocales.filter((locale) =>
        feature?.config?.availableLocales?.includes(locale)
      )
    },
    formattedLocales() {
      return this.availableLocales.map((locale) => ({
        text: this.$t(`language.${locale}`),
        value: locale,
      }))
    },
  },
  methods: {
    async handleLocaleChange(locale) {
      try {
        this.$tracking.event('Settings', 'Clicked', 'Change Locale', locale)
        await changeLocale(locale)
        await this.updateUser()
      } catch (error) {
        this.currentLocale = this.$i18n.locale
        bus.$emit(eventNames.SHOW_SNACKBAR, {
          color: 'error',
          text: this.$t('alerts.language-switch.error'),
        })
      }
    },
    async updateUser() {
      try {
        await this.$apollo.mutate({
          mutation: UPDATE_USER_LOCALE,
          variables: {
            input: {
              appLocale: this.$i18n.locale,
            },
          },
        })
        this.$tracking.event('Settings', 'Edited', 'Update User')
        bus.$emit(eventNames.SHOW_SNACKBAR, {
          color: 'success',
          text: this.$t('alerts.language-switch.success'),
        })

        // Update the language for productFruits
        if (window.productFruits) {
          const productFruits = this.$features.feature(featureNames.PRODUCTFRUITS)
          const availableLanguages = productFruits?.config?.availableLanguages || []
          const fallbackLanguage = productFruits?.config?.fallbackLanguage || 'en'
          const locale = this.$i18n.locale.slice(0, 2)
          window.productFruits.language = availableLanguages.includes(locale)
            ? locale
            : fallbackLanguage
        }
      } catch (e) {
        bus.$emit(eventNames.SHOW_SNACKBAR, {
          color: 'error',
          text: this.$t('alerts.language-switch.error'),
        })
      }
    },
  },
}
</script>

<style scoped>
.language-switch {
  z-index: 42;
}
</style>
